var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:[
    {
      'box-layout': _vm.boxLayout,
      'collapse-sidebar': _vm.collapseSidebar,
      'rtl-layout': _vm.rtlLayout,
    } ],attrs:{"id":"inspire","dark":_vm.darkMode}},[_c('router-view',{attrs:{"auth":_vm.auth,"authenticated":_vm.authenticated}}),_c('notifications',{attrs:{"group":"loggedIn","position":"top right","animation-type":"velocity"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }